<template>
	<div class="banner">
		<div class="container">
			<div class="row banner-text">
				<div class="slider-info col-lg-6">
					<div class="agileinfo-logo pl-2">
						<h2>课程体系 </h2>
						<h4>将学科知识融入编程</h4>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 适合7-16岁，零基础在线学习</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 编程教育与语、数、英等学科教育相融合</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 全面打通编程学科教、学、测、评、练、赛教学环节</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 基于AI Magic机器人硬件研发的专业编程平台</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CourseBanner'
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/css/course/components/CourseBanner.scss';
</style>